import { useState, useEffect } from "react";
import axios from "axios";
import { Newspaper } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsFeed({ onOpenArticle }) {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get(`${API}/news/market`);
        setNews(res.data.news || []);
      } catch { /* */ } finally { setLoading(false); }
    };
    fetchNews();
    const id = setInterval(fetchNews, 300000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="border-t border-zinc-100 dark:border-zinc-800 mt-10 pt-6" data-testid="news-feed">
      <h2 className="text-[10px] tracking-[0.25em] uppercase font-mono text-zinc-400 dark:text-zinc-500 mb-5 flex items-center gap-2">
        <Newspaper size={12} weight="bold" /> Market News
      </h2>
      {loading ? (
        <div className="py-8 text-center">
          <div className="inline-block w-5 h-5 border-2 border-zinc-200 dark:border-zinc-700 border-t-zinc-950 dark:border-t-zinc-100 rounded-full animate-spin" />
        </div>
      ) : news.length === 0 ? (
        <p className="text-xs font-mono text-zinc-300 dark:text-zinc-600">No market news available.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-100 dark:bg-zinc-800">
          {news.map((a, i) => (
            <button key={i} onClick={() => a.link && onOpenArticle(a.link)}
              className="bg-white dark:bg-zinc-950 p-4 text-left hover:bg-zinc-50 dark:hover:bg-zinc-900 transition-colors group"
              data-testid={`market-news-${i}`}>
              <p className="text-sm text-zinc-800 dark:text-zinc-300 line-clamp-2 group-hover:text-zinc-950 dark:group-hover:text-zinc-100 leading-snug">{a.title}</p>
              <p className="text-[11px] font-mono text-zinc-400 dark:text-zinc-500 mt-2">{a.publisher}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
